export default {
      id: "i-yt-circle-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-yt-circle",
      toString: function () {
        return this.url;
      }
    }